import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/euql1n/Workspaces/personal/chonky-website/2.x_docz/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "file-action-basics"
    }}>{`File action basics`}</h1>
    <h2 {...{
      "id": "what-are-file-actions"
    }}>{`What are file actions?`}</h2>
    <p>{`File actions are the most powerful feature Chonky has to offer. They allow you to tweak
file browser behaviour, add custom toolbar buttons, respond to key presses and much
more!`}</p>
    <p>{`To get a sense of how powerful file actions are, consider this - most of the built-in
Chonky features, such as file selections & context menu handling, are implemented using
file actions. In theory, the definitions for these actions could come from user code,
but Chonky provides these features out-of-the-box for convenience.`}</p>
    <h2 {...{
      "id": "what-can-they-do"
    }}>{`What can they do?`}</h2>
    <p>{`Using simple file action definitions, you can do the following:`}</p>
    <ul>
      <li parentName="ul">{`Change file sort function.`}</li>
      <li parentName="ul">{`Change current file view.`}</li>
      <li parentName="ul">{`Toggle boolean options.`}</li>
      <li parentName="ul">{`Transform selection.`}</li>
      <li parentName="ul">{`Add buttons to toolbar or context menu.`}</li>
      <li parentName="ul">{`Response to keyboard shortcuts.`}</li>
      <li parentName="ul">{`Trigger the user-defined action handler.`}</li>
    </ul>
    <p>{`If you dive deeper and make use of `}<a parentName="p" {...{
        "href": "/docs/2.x/file-actions/effects"
      }}>{`file action effects`}</a>{`, you can
go further:`}</p>
    <ul>
      <li parentName="ul">{`Dispatch other file actions.`}</li>
      <li parentName="ul">{`Prevent user-defined action handler from being triggered.`}</li>
      <li parentName="ul">{`Read and modify Chonky's internal Redux state. This allows you to change Chonky's
behaviour in arbitrary ways.`}</li>
    </ul>
    <h2 {...{
      "id": "enabling-file-actions"
    }}>{`Enabling file actions`}</h2>
    <p>{`You can pass custom file actions to Chonky using the `}<inlineCode parentName="p">{`fileActions`}</inlineCode>{` prop on `}<inlineCode parentName="p">{`FileBrowser`}</inlineCode>{`
component:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`import { ChonkyActions, defineFileAction, FileBrowser } from 'chonky';

export const MyFileBrowser = () => {
    const myCustomAction = defineFileAction({
        /* ... */
    } as const);

    const myFileActions = [
        myCustomAction,
        ChonkyActions.UploadFiles,
        ChonkyActions.DownloadFiles,
    ];

    return (
        <FileBrowser files={[]} fileActions={myFileActions}>
            {/* ... */}
        </FileBrowser>
    );
};
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      